<template>
  <vs-tooltip text="Print" position="top">
    <vs-button
      radius
      class="mr-2"
      color="#333f50"
      type="flat"
      @click="print"
      icon="print"
    ></vs-button
  ></vs-tooltip>
</template>

<script>
import moment from "moment";
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  props: {
    dataList: Array,
    headerName: String,
    header: Array,
  },
  data: () => ({
    nwlist: [],
    headerName: "",
    i: "",
    dataList: [],
    selectFilter: [],
    d: "",
    network: "",
    role: "",
    a: [],
    filter_input: [
      {
        alertname: "",
        message: "",
        sensorname: "",
        lastdata: "",
        timestamp: "",
        alertstatus: "",
      },
    ],
    filter_list: [],
    primeTable: "",
    finds: [],
    counter: 0,
    dataBody: [],
    dataExport: [],
    dataActive: "",
  }),
  methods: {
    // print
    print() {
      console.log(this.headerName);
      switch (this.headerName) {
        case "Sensor":
          this.dataList.forEach((element) => {
            if (element.active == "1") {
              this.dataActive = "Active";
            }
            if (element.active == "0") {
              this.dataActive = "Inactive";
            }
            this.dataBody.push({
              name: element.name,
              serial_id: element.serial_id,
              type: element.type,
              network: element.network,
              location: element.location,
              active: this.dataActive,
              signal: "100",
              bat: "100",
            });
          });
          console.log("Uh oh.");
          break;
        case "Gateway":
          this.dataList.forEach((element) => {
            if (element.active == true) {
              this.dataActive = "Active";
            } else {
              this.dataActive = "Inactive";
            }
            this.dataBody.push({
              name: element.name,
              serial_id: element.serial_id,
              type: element.type,
              network: element.network,
              location: element.location,
              active: this.dataActive,
              signal: element.signal,
            });
          });
          console.log("A good day for golf!");
          break;
        case "History Log":
          console.log(this.dataList);
          this.dataBody = this.dataList;
          break;
        //  case "Alert":
        //   var tempData = "";
        //   this.dataList.forEach((element) => {
        //     element.lastdata.forEach((data) => {
        //       Object.keys(data).forEach((key) => {
        //         tempData += key + " " + data[key] + " ";
        //       });
        //       if (element.alertstatus == true) {
        //         this.dataActive = "Armed";
        //       } else {
        //         this.dataActive = "Disarmed";
        //       }
        //       this.dataBody.push({
        //         alertname: element.alertname,
        //         message: element.message,
        //         sensorname: element.sensorname,
        //         alertname: element.alertname,
        //         lastdata: tempData,
        //         message: element.message,
        //         timestamp: element.timestamp,
        //         status: this.dataActive,
        //       });
        //       tempData = "";
        //     });
        //   });
        //   console.log("A good day for golf!");
        //   break;
        case "Active Users":
          this.dataList.forEach((element) => {
            this.dataBody.push({
              name: element.name,
              username: element.username,
              email: element.email,
              line: element.line,
              islogin: element.islogin,
              status: element.status,
            });
          });
          break;
        case "Inactive Users":
          this.dataList.forEach((element) => {
            this.dataBody.push({
              name: element.name,
              username: element.username,
              email: element.email,
              line: element.line,
              islogin: element.islogin,
              status: element.status,
            });
          });
          break;
        case "Pending Users":
          this.dataList.forEach((element) => {
            this.dataBody.push({
              name: element.name,
              username: element.username,
              email: element.email,
              line: element.line,
              islogin: element.islogin,
              status: element.status,
            });
          });
          break;
        case "Network":
          this.dataList.forEach((element) => {
            this.dataBody.push({
              name: element.name,
              gateway: element.gateway,
              sensors: element.sensors,
            });
          });
          console.log(this.dataBody);
          console.log("A good day for golf!");
          break;
        case "Work Order":
          let dataPriority = "";
          this.dataList.forEach((element) => {
            if (element.priority == "1") {
              this.dataPriority = "1-Low Priority";
            } else if (element.priority == "2") {
              this.dataPriority = "2-Medium Priority";
            } else if (element.priority == "3") {
              this.dataPriority = "3-High Priority";
            } else {
              this.dataPriority = "-";
            }
            this.dataBody.push({
              Work_ID: element.id,
              priority: this.dataPriority,
              work_order: element.name,
              asset: element.asset,
              name: element.username,
              email: element.email,
              creator: "creator",
              start_date: element.plandate,
              actual_start_date: element.startdate,
              end_date: element.duedate,
              actual_end_date: element.finishtime,
              status: element.iscomplete,
              detail: element.detail,
            });
          });
          console.log(this.dataBody);
          console.log("A good day for golf!");
          break;
        case "RFID":
          console.log( this.dataList);
          this.dataList.forEach((element) => {
            // console.log(element);
            this.dataBody.push({
              ID:element.id,
              Tag:element.tag,
              Name:element.name,
              Status:element.status=="🔴 Absent" ? "Absent"  : "Present",
              Department:element.dept
            });
          });
          break;

        default:
          console.log("Try looking up for a hint.");
      }

      console.log(this.dataBody);
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(8).text(this.headerName + " List", 40, 40); //header
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat); //timestamp
      var values = this.dataBody.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: {
          fillColor: [50, 192, 64],
          textColor: [255, 255, 255],
          overflow: "wrap",
        },
        styles: { fontSize: 6, theme: "plain", cellWidth: "15" },
        head: [this.header],
        body: values,
        margin: { top: 50 },
      });
      doc.autoPrint();
      doc.output("dataurlnewwindow");
      this.dataBody = []; //Clear dataBody
      this.dataActive = "";
    },
  },
};
</script>

<style>
</style>